import { PageRouteProps } from "../../types";

export const pageRoutes: PageRouteProps[] = [
  {
    pathName: "/page",
    component: "Page",
    type: "public",
    mode: "dynamic",
  },
];
